import { render, staticRenderFns } from "./MotorList.vue?vue&type=template&id=53ff4d3c"
import script from "./MotorList.vue?vue&type=script&lang=js"
export * from "./MotorList.vue?vue&type=script&lang=js"
import style0 from "./MotorList.vue?vue&type=style&index=0&id=53ff4d3c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports